export const AGE_GROUPS = [
  { value: "board", label: "Board Books", range: "Birth – 18 months" },
  { value: "picture", label: "Picture Books", range: "18 months – 3 years" },
  { value: "early", label: "Early Readers", range: "3 – 5 years" },
  { value: "beginning", label: "Beginning Readers", range: "5 – 8 years" },
];

// Spine palette drawn from the brand logo (pink, sky blue, sunflower yellow)
// plus complementary warm and sage tones for variety.
export const SPINE_PALETTE = [
  "#EE9BA7", // logo pink / coral
  "#A8D8EA", // logo sky blue
  "#F7C94B", // logo sunflower yellow
  "#2B328C", // brand indigo
  "#0E232E", // brand navy
  "#7EC8E3", // tagline sky
  "#D48C5A", // warm clay
  "#7FA98F", // sage
];

export function pickSpineColor(seed) {
  if (!seed) return SPINE_PALETTE[0];
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  return SPINE_PALETTE[hash % SPINE_PALETTE.length];
}
